import { StandardPatcher } from "../../patcher/patch-types";
import { Show } from "solid-js";

export default function (patcher: StandardPatcher) {
  const [enabled, setEnabled] = patcher.enabled;

  return (
    <div class="patch form-check form-switch">
      <input class="form-check-input" type="checkbox" id={patcher.id} checked={enabled()} onchange={(e) => setEnabled(e.target.checked)} />
      <label for={patcher.id} class="form-check-label">{patcher.name}</label>
      <Show when={patcher.tooltip}>
        <div class="badge tip text-bg-secondary" innerHTML={patcher.tooltip}></div>
      </Show>
      <Show when={patcher.danger}>
        <div class="badge tip text-bg-danger" innerHTML={patcher.danger}></div>
      </Show>
    </div>
  );
}
